import i18n from "i18next";
import Backend from "i18next-http-backend";
import ChainedBackend from "i18next-chained-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import LocalStorageBackend from "i18next-localstorage-backend";

// Bump this whenever the files in public/assets/i18n change. The localStorage
// backend caches translations for weeks, so without a version change existing
// browsers keep serving the stale copy and new keys render as raw key strings.
const TRANSLATIONS_VERSION = "v7";

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      backends: [LocalStorageBackend, Backend],
      // translation file path
      backendOptions: [
        {
          expirationTime: 4 * 7 * 24 * 60 * 60 * 1000, // 4 weeks
          defaultVersion: TRANSLATIONS_VERSION
        },
        {
          loadPath: "/assets/i18n/{{ns}}/{{lng}}.json"
        }
      ]
    },
    fallbackLng: "en",
    // please disable debug in production
    debug: true,
    //ns means namespace. It is used to group translations into different files.
    // can have multiple namespaces, in case you want to divide a huge
    // translation into smaller pieces and load them on demand
    keySeparator: ".",
    nsSeparator: ":",
    interpolation: {
      escapeValue: false,
      formatSeparator: ","
    },
    react: {
      wait: true
    }
  });

export default i18n;
